/**
* author: duxin
* date: 2020/4/8
* describe:
*/

<template>
    <router-view></router-view>
</template>

<script>
    export default {
        name: "index"
    }
</script>

<style scoped>

</style>